import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconTextAlignmentDistribute$1 = /*@__PURE__*/ proxyCustomElement(class WppIconTextAlignmentDistribute extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-text-alignment-distribute", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M4.78033 6.28033C5.07322 5.98744 5.07322 5.51256 4.78033 5.21967L4.56066 5L17.25 5C17.6642 5 18 4.66421 18 4.25C18 3.83579 17.6642 3.5 17.25 3.5L4.56066 3.5L4.78033 3.28033C5.07322 2.98744 5.07322 2.51256 4.78033 2.21967C4.48744 1.92678 4.01256 1.92678 3.71967 2.21967L2.21967 3.71967C1.92678 4.01256 1.92678 4.48744 2.21967 4.78033L3.71967 6.28033C4.01256 6.57322 4.48744 6.57322 4.78033 6.28033ZM18 9.25C18 9.66421 17.6642 10 17.25 10H2.75C2.33579 10 2 9.66421 2 9.25C2 8.83579 2.33579 8.5 2.75 8.5H17.25C17.6642 8.5 18 8.83579 18 9.25ZM2.75 13.5H15.4393L15.2197 13.2803C14.9268 12.9874 14.9268 12.5126 15.2197 12.2197C15.5126 11.9268 15.9874 11.9268 16.2803 12.2197L17.7803 13.7197C18.0732 14.0126 18.0732 14.4874 17.7803 14.7803L16.2803 16.2803C15.9874 16.5732 15.5126 16.5732 15.2197 16.2803C14.9268 15.9874 14.9268 15.5126 15.2197 15.2197L15.4393 15H2.75C2.33579 15 2 14.6642 2 14.25C2 13.8358 2.33579 13.5 2.75 13.5Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-text-alignment-distribute-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-text-alignment-distribute", "wpp-icon-text-alignment-distribute-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-text-alignment-distribute-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-text-alignment-distribute-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconTextAlignmentDistribute$1);
      }
      break;
  } });
}

const WppIconTextAlignmentDistribute = WppIconTextAlignmentDistribute$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconTextAlignmentDistribute, defineCustomElement };
